import styled from "@emotion/styled";
import { Icon, Theme, Typography, useTheme } from "@yuno/design-system-web";
import { useContext } from "react";
import { ThemeContext } from "../../../../context/theme-context";
import { CustomTheme } from "../../../../types/custom-theme";
import { Button } from "./button";
import { PaymentMethods } from "./payment-methods";
import { useTranslation } from 'react-i18next'


const Panel = styled.div(({ customTheme }: { customTheme?: CustomTheme }) => ({
  overflowY: "auto",
  overflowX: "hidden",
  width: "381px",
  height: "100%",
  background: customTheme.payment_form.container.outside_color,
  zIndex: 1000,
  position: "relative",
  boxShadow: '-10px 0px 20px rgba(40, 42, 48, 0.04)',
  "& p": {
    //color: customTheme.payment_form.field.font_color,
  },
}));

const Inner = styled.div(({ theme }: { theme?: Theme }) => ({
  width: "110%",
  height: "100%",
  transform: "scale(0.65)",
  position: "relative",
  top: "-100px",
  left: "-15px",
}));

const Title = styled(Typography)<{ theme?: Theme }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;

  p {
    font-size: ${({ theme }) => theme.typography.base.regular.fontSize};
  }

  p.title-darkMode {
    color: ${({ theme }) => theme.palette.neutral.white[0]};
  }
`;

const Divisor = styled.div<{ theme?: Theme; customTheme: CustomTheme }>`
  margin-top: 26px;
  margin-bottom: 26px;
  width: 100%;
  height: 1px;
  background: ${({ customTheme }) =>
    customTheme.payment_form.container.fill_color};
  position: relative;

  p {
    background: ${({ customTheme }) =>
      customTheme.payment_form.container.outside_color};
    text-align: center;
    top: -11px;
    left: 163px;
    padding-left: 4px;
    padding-right: 4px;
    width: 97px;
    font-size: ${({ theme }) => theme.typography.small.regular.fontSize};
    position: absolute;
  }

  p.title-darkMode {
    color: ${({ theme }) => theme.palette.neutral.white[0]};
  }
`;

export const RightPanel = () => {
  const { t } = useTranslation()
  const { customTheme, themeSelected } = useContext(ThemeContext);
  const theme: Theme = useTheme();

  return (
    <Panel customTheme={customTheme}>
      <Inner>
        <Title>
          <Typography className={`title-${themeSelected}`}>
            {t('titleCondition')}
          </Typography>
          <Icon name="CaretUp" color={theme.palette.grey[5]} />
        </Title>
      {/*   <SavedMethods />
        <CardForm />
        <Divisor customTheme={customTheme}>
          <Typography className={`title-${themeSelected}`}>
            Or pay with
          </Typography>
        </Divisor> */}
        <PaymentMethods />
        <Button />
      </Inner>
    </Panel>
  );
};
